// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".face[data-v-784d5393]{padding-left:.5rem;font-family:Segoe UI,Tahoma,Geneva,Verdana,sans-serif}", ""]);
// Exports
module.exports = exports;
